"use strict";
exports.__esModule = true;
exports.RATE_LIMIT_ERROR_MODAL_CONTENT = void 0;
exports.RATE_LIMIT_ERROR_MODAL_CONTENT = {
    TITLE: 'Wait and try again',
    BODY: 'We’re having issues processing your request. You can try again in a few moments. Please wait a few moments before trying again.',
    SIMPLIFIED_PAYMENTS_BODY: 'We noticed you tried changing your monthly rent very quickly after your last attempt. Please wait a few moments before trying again.'
};
